import { createContext, useContext, ReactElement } from 'react';
import { IListItem, IListProduct } from 'mod/product-list/interface';
import { ThemeImageProps } from '@base/lib/ThemeImage';
import { IRateProps, RateType } from '@base/lib/Rate';
import { ButtonProps } from '@base/lib/Button';
import { IProductProgressProps } from 'mod/product-list/ProductProgress';
import { TDiscountStyle } from 'mod/product/interface';

export type IProductContext = {
    product: IListProduct;
    products: IListProduct[];
    canLinkJump?: boolean;
    onChangeProduct: (product: IListProduct) => void;
    num: number;
    optionType: 'image' | 'text';
    //props
    imageSize: number;
    link?: boolean;
    picture?: ThemeImageProps & {
        showHoverPic?: boolean;
        tags?: boolean | ReactElement | ITagsConfig;
        showSoldOut?: boolean;
        onQuickView?: (variantId: string) => void;
        spaceAroundPicture?: number;
        spaceBelowPicture?: number;
        fixed?: boolean;
        mask?: ReactElement;
    };
    title?: boolean;
    rate?: boolean | {
        type?: RateType;
        starSize?: IRateProps['starSize'];
    },
    prices?: boolean | {
        showMarketPrice?: boolean;
    };
    addCart?: boolean | ButtonProps & {
        qty?: number;
        successCallback?: () => void;
        text?: string;
    };
    progress?: boolean | IProductProgressProps;
    points?: boolean;
    options?: boolean | {
        size?: number;
        space?: number;
        textHeight?: number;
        textSideSpace?: number;
        textSpace?: number;
        maxDisplayNum?: number;
        showAll?: boolean;
        onChange?: (product: IListProduct) => void;
    };
    track?: {
        module?: string;
        listTrackCode?: string;
        itemType?: IListItem['type'];
        targetPrefix?: string;
        position?: number | string;
    };
    onClick?: (product: IListProduct) => void;
};

export type ITagsConfig = {
    productTag?: boolean | Partial<IProductTagConfig>;// 商品标签
    activityTag?: boolean | Partial<IActivityTagConfig>;// 活动标签
};

export type IProductTagConfig = {
    tagName: string; //计算结果，配置无效
    discountStyle: TDiscountStyle; //折扣展示样式
};

export type IActivityTagConfig = {
    tagName: string; //计算结果，配置无效
    discountStyle: TDiscountStyle; //折扣展示样式
    showName: boolean;
    showDiscount: boolean;
};

export const ProductContext = createContext<IProductContext>({} as IProductContext);

export function useProductContext(): IProductContext {
    return useContext(ProductContext);
}
